module.exports = __webpack_public_path__ + "static/media/md-cash.51d067e0.svg";